import { Component, Input } from '@angular/core';
import { vwRoomState } from '@app/kip/viewdto/vwdailytask/vwRoomState';
import { RoomState } from '@app/shared/enums/roomstates';
import { RoomStateTransition } from '@app/shared/enums/roomstatetransitions';


@Component({
  selector: 'room-state-transition',
  templateUrl: './room-state-transition.component.html',
  styleUrls: ['./room-state-transition.component.scss']
})


export class RoomStateTransitionComponent {
  @Input() roomStateTransitionCode: string;
  @Input() roomStateCode: RoomState;
  @Input() checkedIn: boolean;
  @Input() checkedOut: boolean;
  @Input() outOfOrderEndDate: string;
  @Input() lateCheckOut: boolean;
  @Input() earlyCheckin: boolean;
  


  leftIconColorStyle() {
    let styles = {};
    styles["font-size"] = "18px";
    if (this.roomStateTransitionCode == null) {
      if (this.roomStateCode == RoomState.OUT_OF_ORDER) {
        styles["background-color"] = "#000000";
        styles["color"] = "#fdfdfd";
      }
      if (this.roomStateCode == RoomState.RESERVED_CLEAN ||
        this.roomStateCode == RoomState.RESERVED_DIRTY ||
        this.roomStateCode == RoomState.RESERVED_OK
      ) {
        styles["background-color"] = "#ffffff00";
        styles["color"] = "#85b0ec";
      }
      if (this.roomStateCode == RoomState.EMPTY_CLEAN ||
        this.roomStateCode == RoomState.EMPTY_AVAILABLE ||
        this.roomStateCode == RoomState.EMPTY_DIRTY
      ) {

        styles["background-color"] = "#FFFFFF00";
        styles["color"] = "#ada8a8";
      }
    }
    else {
      if (this.roomStateTransitionCode == RoomStateTransition.DAY_USE) {
        styles["background-color"] = "#FFFFFF00";
        styles["color"] = "#f35870";


      }
      if (this.roomStateTransitionCode == RoomStateTransition.DEP_TO_ARR ||
        this.roomStateTransitionCode == RoomStateTransition.DEP_TO_EMPTY ||
        this.roomStateTransitionCode == RoomStateTransition.DEP_TO_OOO    // dátum jön majd  

      ) {
        if (this.lateCheckOut) {
          styles["background-color"] = "#FFFFFF00";
          styles["color"] = "#f35870";
        }
        else {
          styles["background-color"] = "#f35870";
          styles["color"] = "#FFFFFF";
        }

      }
      if (this.roomStateTransitionCode == RoomStateTransition.OOO_TO_ARR ||
        this.roomStateTransitionCode == RoomStateTransition.OOO_TO_EMPTY ||
        this.roomStateTransitionCode == RoomStateTransition.OOO_TO_OOO
      ) {
        styles["background-color"] = "#000000"
        styles["color"] = "#fdfdfd";
      }
      if (this.roomStateTransitionCode == RoomStateTransition.EMPTY_TO_ARR ||
        this.roomStateTransitionCode == RoomStateTransition.EMPTY_TO_OOO
      ) {
        styles["background-color"] = "#FFFFFF00";
        styles["color"] = "#ada8a8";
      }
      if (this.roomStateTransitionCode == RoomStateTransition.OCCUPIED ||
        this.roomStateTransitionCode == RoomStateTransition.OCCUPIED_BED) {
        styles["background-color"] = "#ffffff00";
        styles["color"] = "#85b0ec";
      }

      if(this.roomStateTransitionCode == RoomStateTransition.EMPTY_TO_EMPTY) {
        styles["background-color"] = "#FFFFFF00";
        styles["color"] = "#ada8a8";
      }
    }
    return styles;
  }

  leftIconClass() {
    if (this.roomStateTransitionCode == null) {
      if (this.roomStateCode == RoomState.OUT_OF_ORDER) {
        return "mdi mdi-cog-outline icon-size";
      }
      if (this.roomStateCode == RoomState.EMPTY_CLEAN ||
        this.roomStateCode == RoomState.EMPTY_AVAILABLE ||
        this.roomStateCode == RoomState.EMPTY_DIRTY
      ) {
        return "mdi mdi-border-all-variant icon-size";
      }
    }
    else {
      if (this.roomStateTransitionCode == RoomStateTransition.DAY_USE) {
        return "mdi mdi-alert-octagon icon-size";
      }
      if (this.roomStateTransitionCode == RoomStateTransition.DEP_TO_ARR ||
        this.roomStateTransitionCode == RoomStateTransition.DEP_TO_EMPTY ||
        this.roomStateTransitionCode == RoomStateTransition.DEP_TO_OOO    // dátum jön majd  

      ) {
        if (this.lateCheckOut) {
          return "mdi mdi-alpha-l-box icon-size";
        }
        else {
          return "mdi mdi-arrow-right-bold icon-size";
        }
      }
      if (this.roomStateTransitionCode == RoomStateTransition.OOO_TO_ARR ||
        this.roomStateTransitionCode == RoomStateTransition.OOO_TO_EMPTY ||
        this.roomStateTransitionCode == RoomStateTransition.OOO_TO_OOO
      ) {
        return "mdi mdi-cog-outline icon-size";
      }
      if (this.roomStateTransitionCode == RoomStateTransition.EMPTY_TO_ARR ||
        this.roomStateTransitionCode == RoomStateTransition.EMPTY_TO_OOO ||
        this.roomStateTransitionCode == RoomStateTransition.EMPTY_TO_EMPTY        
      ) {
        return "mdi mdi-border-all-variant icon-size";
      }
      if (this.roomStateTransitionCode == RoomStateTransition.OCCUPIED) {
        return "mdi mdi-delete-variant icon-size";
      }
      if (this.roomStateTransitionCode == RoomStateTransition.OCCUPIED_BED) {
        return "mdi mdi-bed icon-size";
      }
    }
  }

  leftTextStyle() {
    let styles = {};
    styles["font-size"] = "18px";
    styles["padding-left"] = "5px";
    styles["font-weight"] = "bold";
    styles["color"] = "#f35770";
    return styles;
  }

  leftTextValue() {
    if (this.checkedIn && this.roomStateTransitionCode === RoomStateTransition.DAY_USE) {
      return "CI"
    }
    if (this.checkedOut) {
      if (this.roomStateTransitionCode !== RoomStateTransition.DAY_USE) {
        return "CO";
      } else {
        return "CO";  // ez a CI CO lesz majd egyszer
      }
    }
    if (this.roomStateCode == RoomState.OUT_OF_ORDER && this.roomStateTransitionCode === null) {
      return this.outOfOrderEndDate;
    }

  }

  rightIconColorStyle() {
    let styles = {};
    styles["font-size"] = "18px";
    switch (this.roomStateTransitionCode) {
      case RoomStateTransition.OCCUPIED:
        styles["background-color"] = "#ffffff00";
        styles["color"] = "#85b0ec";
        break;
      case RoomStateTransition.OCCUPIED_BED:
        styles["background-color"] = "#ffffff00";
        styles["color"] = "#85b0ec";
        break;
      case RoomStateTransition.DEP_TO_ARR:
        styles["background-color"] = "#779a34";
        styles["color"] = "#fdfdfd";
        styles["margin-right"] = "0.2em";
        break;
      case RoomStateTransition.EMPTY_TO_ARR:
        styles["background-color"] = "#779a34";
        styles["color"] = "#fdfdfd";
        styles["margin-right"] = "0.2em";
        break;
      case RoomStateTransition.EMPTY_TO_OOO:
        styles["background-color"] = "#000000";
        styles["color"] = "#fdfdfd";
        break;
      case RoomStateTransition.DEP_TO_OOO:
        styles["background-color"] = "#000000"
        styles["color"] = "#fdfdfd";
        break;
      case RoomStateTransition.OOO_TO_OOO:
        styles["background-color"] = "#000000"
        styles["color"] = "#fdfdfd";
        break;
      case RoomStateTransition.DEP_TO_EMPTY:
        styles["background-color"] = "#FFFFFF00";
        styles["color"] = "#ada8a8";
        break;
      case RoomStateTransition.OOO_TO_EMPTY:
        styles["background-color"] = "#FFFFFF00";
        styles["color"] = "#ada8a8";
        break;
      case RoomStateTransition.OOO_TO_ARR:
        styles["background-color"] = "#779a34";
        styles["color"] = "#fdfdfd";
        styles["margin-right"] = "0.2em";
        break;
      case RoomStateTransition.DAY_USE:
        styles["background-color"] = "#779a34";
        styles["color"] = "#fdfdfd";
        styles["margin-right"] = "0.2em";
        break;
      case RoomStateTransition.EMPTY_TO_EMPTY:
          styles["background-color"] = "#FFFFFF00";
          styles["color"] = "#ada8a8";
          break;
    }

    return styles;

    //--------

  }
  rightIconClass() {
    if (this.roomStateTransitionCode == RoomStateTransition.DEP_TO_EMPTY ||
      this.roomStateTransitionCode == RoomStateTransition.OOO_TO_EMPTY   || 
      this.roomStateTransitionCode == RoomStateTransition.EMPTY_TO_EMPTY) {
      return "mdi mdi-border-all-variant icon-size"
    }
    if (this.roomStateTransitionCode == RoomStateTransition.DEP_TO_ARR ||
      this.roomStateTransitionCode == RoomStateTransition.EMPTY_TO_ARR ||
      this.roomStateTransitionCode == RoomStateTransition.OOO_TO_ARR
    ) {
      if (this.earlyCheckin) {
        return "mdi mdi-alpha-e-box-outline icon-size";
      } else {
        return "mdi mdi-arrow-left-bold icon-size";

      }
    }
    if (this.roomStateTransitionCode == RoomStateTransition.DAY_USE) {
      return ""; //return "mdi mdi-arrow-left-bold icon-size"; 
    }

    if (this.roomStateTransitionCode == RoomStateTransition.DEP_TO_OOO ||
      this.roomStateTransitionCode == RoomStateTransition.OOO_TO_OOO ||
      this.roomStateTransitionCode == RoomStateTransition.EMPTY_TO_OOO
    ) {
      return "mdi mdi-cog-outline icon-size";
    }
  }
  rightTextStyle() {
    let styles = {};
    styles["font-size"] = "18px";
    styles["padding-left"] = "5px";
    styles["font-weight"] = "bold";
    styles["color"] = "#779a34";
    return styles;

  }
  rightTextValue() {
    if (this.roomStateCode == RoomState.OUT_OF_ORDER && (!(this.roomStateTransitionCode === RoomStateTransition.OOO_TO_OOO ||
      this.roomStateTransitionCode === RoomStateTransition.OOO_TO_EMPTY))) {
      return this.outOfOrderEndDate;
    }
    if (this.roomStateCode == RoomState.OUT_OF_ORDER && this.roomStateTransitionCode == null) {
      return this.outOfOrderEndDate;
    }

    if (this.roomStateCode == RoomState.OUT_OF_ORDER && this.roomStateTransitionCode === RoomStateTransition.OOO_TO_OOO) {
      return this.outOfOrderEndDate;
    }
    if (this.checkedIn) {
      if (this.roomStateTransitionCode == RoomStateTransition.OCCUPIED_BED || this.roomStateTransitionCode == RoomStateTransition.OCCUPIED) {
        return ""
      } else {
        return "CI";
      }

    }
  }
}
